import { appConfigStore } from 'Models/AppConfigStore';
import { store } from 'Models/Store';
import * as React from 'react';
import { formatCurrency } from 'Util/_HumanWritten/CurrencyUtils';
import { upperCaseFirst } from 'Util/StringUtils';
import { isNullOrUndefined } from 'Util/TypeGuards';
import { getTravelCreditTerminology } from 'Views/Components/_HumanWritten/Bookings/BookingDetailedView/Modals/CancelBooking/NewCancelBookingModal';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

export interface TravelCreditProps {
	refundAmount: number;
	forceFerryCreditRefund: boolean;
}

export function TravelCredit({ refundAmount, forceFerryCreditRefund }: TravelCreditProps) {
	const allowed = appConfigStore.allowedRefundMethodsFor(store.isStaff);
	// Travel credit display is suppressed when the user is taking a bank refund or credit isn't an option.
	if (!forceFerryCreditRefund && (allowed.has('Bank') || !allowed.has('Credit'))) {
		return null;
	}

	if (refundAmount === 0 || isNullOrUndefined(refundAmount)) {
		return null;
	}

	return (
		<div className="refund-bookings__list">
			<div className="card-refund-item">
				<div className="top-content">
					<span className="card-info">
						<Icon name="universal_currency_alt" useMaterialIcons />
						{upperCaseFirst(getTravelCreditTerminology(forceFerryCreditRefund))}
					</span>
					<div className="refund-amount-display">
						<p className="refund-amount">{formatCurrency(refundAmount ?? 0)}</p>
					</div>
				</div>
			</div>
		</div>
	);
}
